import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import SButton from "components/Common/Button"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import SeasonAction from "store/season-resource/actions"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/newTables/TableContainer"

export default function RTWSeason() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [pagination, setPagination] = React.useState({
    page: 0,
    size: 10,
  })
  const [params, setParams] = React.useState({
    page: 0,
    size: 10,
  })
  const [filter, setFilter] = useState({ code: "", name: "" })

  const columns = React.useMemo(
    () => [
      {
        Header: "シーズン名",
        accessor: "name",
        defaultCanSort: false,
      },
      {
        Header: "シーズンコード",
        accessor: "code",
        defaultCanSort: false,
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(
                  history.push(`/master/rtw-season/${cell.row.original.id}`)
                )
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  React.useEffect(() => {
    dispatch(SeasonAction.getListPage({ ...params, ...pagination }))
  }, [params, pagination])

  const onChangeFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    setParams({
      ...filter,
      page: 0,
      size: 10,
    })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"RTWシーズンマスター"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={3}>
                <TextInputWithLabel
                  label={"シーズン名"}
                  placeholder={""}
                  value={filter.name}
                  type="text"
                  name="name"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3}>
                <TextInputWithLabel
                  label={"シーズンコード"}
                  placeholder={""}
                  value={filter.code}
                  type="text"
                  name="code"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3} className="d-flex align-content-end flex-wrap">
                <SButton className="mx-2 button" onClick={() => onSearch()}>
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row className="mb-3">
              <Col sm="6" />
              <Col
                sm="6"
                className="d-flex align-items-end justify-content-end"
              >
                <SButton
                  className="mx-2 button"
                  onClick={() => history.push("/master/rtw-season/add")}
                >
                  新規登録
                </SButton>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                {store.seasonPage.pageData.loading ? (
                  <Skeleton count={5} />
                ) : store.seasonPage.pageData.data?.content?.length === 0 ? (
                  <h3 className="text-center">No Data to Display</h3>
                ) : (
                  <TableContainer
                    data={store.seasonPage.pageData.data?.content || []}
                    columns={columns}
                    pagination
                    page={pagination.page}
                    size={pagination.size}
                    count={store.seasonPage.pageData.data?.totalPages || 1}
                    setParams={setPagination}
                    params={pagination}
                  />
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
